export const getType = (value: any) => {
  const result = /\s(.*)\]$/.exec(toString.call(value));
  // return (result ?? [])[1];
  return result![1];
};

export function isObject(obj: any): obj is Object {
  return getType(obj) === 'Object';
}

export function isRegExp(v: any): v is RegExp {
  return getType(v) === 'RegExp';
}

export const isFunction = (value: any): value is Function => getType(value) === 'Function';

export const isSymbol = (value: any): value is Symbol => getType(value) === 'Symbol';

export const isArray = <T = any>(value: any): value is T[] => getType(value) === 'Array';

export const isNumber = (value: any): value is Number => getType(value) === 'Number';

export const isBoolean = (value: any): value is Boolean => getType(value) === 'Boolean';

export const isString = (value: any): value is String => getType(value) === 'String';

export const isDate = (value: any): value is Date => getType(value) === 'Date';

export const isPromise = <T = any>(value: any): value is Promise<T> => getType(value) === 'Promise';
